'use client';

import { c as _c } from "react/compiler-runtime";
import { useId, type InputHTMLAttributes, type ReactNode } from 'react';
import { NEPAL_PHONE_COUNTRY_CODE, NEPAL_PHONE_MAX_LENGTH, sanitizeNepalPhoneNumber } from '@repo/auth/nepal-phone';
type NepalPhoneInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'prefix' | 'value'> & {
  action?: ReactNode;
  containerClassName?: string;
  error?: ReactNode;
  isVerified?: boolean;
  onValueChange: (value: string) => void;
  value: string;
};
export const NepalPhoneInput = t0 => {
  const $ = _c(45);
  let action;
  let className;
  let containerClassName;
  let disabled;
  let error;
  let id;
  let onValueChange;
  let props;
  let readOnly;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      action,
      className,
      containerClassName,
      disabled,
      error,
      id,
      isVerified: t1,
      onValueChange,
      readOnly,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = action;
    $[2] = className;
    $[3] = containerClassName;
    $[4] = disabled;
    $[5] = error;
    $[6] = id;
    $[7] = onValueChange;
    $[8] = props;
    $[9] = readOnly;
    $[10] = t1;
    $[11] = value;
  } else {
    action = $[1];
    className = $[2];
    containerClassName = $[3];
    disabled = $[4];
    error = $[5];
    id = $[6];
    onValueChange = $[7];
    props = $[8];
    readOnly = $[9];
    t1 = $[10];
    value = $[11];
  }
  const isVerified = t1 === undefined ? false : t1;
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const messageId = `${inputId}-message`;
  const t2 = `grid gap-1.5 ${containerClassName ?? ""}`;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>Phone number</span>;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== isVerified) {
    t4 = isVerified ? <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-medium text-emerald-700">Verified</span> : null;
    $[13] = isVerified;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== inputId || $[16] !== t4) {
    t5 = <label htmlFor={inputId} className="flex items-center gap-2 text-sm font-medium text-foreground">{t3}{t4}</label>;
    $[15] = inputId;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const t6 = `flex h-9 min-w-0 flex-1 overflow-hidden rounded-md border bg-transparent shadow-xs transition-[color,box-shadow] focus-within:ring-[3px] ${error ? "border-destructive ring-destructive/20" : "border-input focus-within:border-ring focus-within:ring-ring/50"} ${disabled ? "cursor-not-allowed opacity-50" : ""}`;
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex shrink-0 items-center border-r border-input bg-muted/45 px-3 text-sm font-medium text-muted-foreground">{NEPAL_PHONE_COUNTRY_CODE}</div>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = Boolean(error) || undefined;
  const t9 = error ? messageId : undefined;
  const t10 = `min-w-0 flex-1 bg-transparent px-3 py-1 text-base leading-[1.75] outline-none placeholder:text-muted-foreground/55 disabled:pointer-events-none disabled:cursor-not-allowed md:text-sm ${className ?? ""}`;
  let t11;
  if ($[19] !== onValueChange) {
    t11 = event_0 => onValueChange(sanitizeNepalPhoneNumber(event_0.target.value));
    $[19] = onValueChange;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== disabled || $[22] !== inputId || $[23] !== props || $[24] !== readOnly || $[25] !== t10 || $[26] !== t11 || $[27] !== t8 || $[28] !== t9 || $[29] !== value) {
    t12 = <input {...props} id={inputId} type="tel" inputMode="numeric" maxLength={NEPAL_PHONE_MAX_LENGTH} pattern="9[0-9]{9}" placeholder="9800000000" disabled={disabled} readOnly={readOnly} value={value} aria-invalid={t8} aria-describedby={t9} className={t10} onBeforeInput={_temp} onChange={t11} />;
    $[21] = disabled;
    $[22] = inputId;
    $[23] = props;
    $[24] = readOnly;
    $[25] = t10;
    $[26] = t11;
    $[27] = t8;
    $[28] = t9;
    $[29] = value;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t6) {
    t13 = <div className={t6}>{t7}{t12}</div>;
    $[31] = t12;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== action || $[35] !== t13) {
    t14 = <div className="flex min-w-0 items-center gap-2">{t13}{action}</div>;
    $[34] = action;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== error || $[38] !== messageId) {
    t15 = error ? <p id={messageId} className="text-xs text-destructive">{error}</p> : null;
    $[37] = error;
    $[38] = messageId;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t2 || $[43] !== t5) {
    t16 = <div className={t2}>{t5}{t14}{t15}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t2;
    $[43] = t5;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  return t16;
};
function _temp(event) {
  const inputData = (event.nativeEvent as InputEvent).data;
  if (inputData && /\D/u.test(inputData)) {
    event.preventDefault();
  }
}